import { Component, Input } from '@angular/core';

@Component({
	selector: 'au-body-text',
	templateUrl: 'au-body-text.component.html',
	styleUrls: ['au-body-text.component.scss'],
	imports: [],
})
export class AuBodyTextComponent {
	@Input() text: string;
	@Input() smallFont = false;
	@Input() fallbackText = '';
}
